import { SLOTS_APIS } from "@/api_framework/api_config";

import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import { IBookingCommentsAlternativeCouponResponse } from "@/api_framework/api_modals/Bookings";
import { setAlternativeCouponData } from "@/app_redux/reducers/slices/auth/slots_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useBookingAlternativCouponListAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(SLOTS_APIS?.ALTERNATIVE_COUPONS_LIST?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IBookingCommentsAlternativeCouponResponse>) => {
          if (res.data.status === true) {
            //
            dispatch(
              setAlternativeCouponData({
                data: res.data.data,
              }),
            );
            // dispatch(
            //   setLoading({
            //     key: "isOrgBookingStatusesInProgress",
            //     status: true,
            //   })
            // );
          } else {
            // dispatch(
            //   setOrgBookingStatuses({
            //     data: [],
            //   })
            // );
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
